import { render } from "./MedicalDirectoryList.vue?vue&type=template&id=12ab8c28"
import script from "./MedicalDirectoryList.vue?vue&type=script&lang=js"
export * from "./MedicalDirectoryList.vue?vue&type=script&lang=js"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__